import { IStringAnyMap } from "src/app/app.types";

export const environment = {
    production: false,

    boox: {
        api: {
            host: 'https://kapa.dev.ketchum.fspoon.org',
            apiKey: 'c9e2da2d935edb0a8611315feae5952190e5a72b9642f519982bf7816c220f07',
            rootPath: 'api/v2',
            envPath: 'system/environment',
            headerApiKey: 'X-BooX-API-Key',
            headerSessionToken: 'X-BooX-Session-Token',
            sessionKey: 'session_api',
        },
    },
    defaultBoox: 'api',

    STORAGE_KEY: {
        ENVIRONMENT: 'environment',
    },
    COOKIE_KEY: {
        LANGUAGE: 'language'
    },
    // 
    storageSalt: 'djoi3df3dujiod',

    appRootPath : '/apps',

    apps : {
        none : '',
        profile : '/_apps/profile/',
        flow : '/_apps/flow/',
        card : '/_apps/card/',
        veri : '/_apps/veri/',
        people : '/_apps/people/',
        helpdesk : 'https://support.flyingspoon.de'
    },
    defaultApp : '/app/flow',

    sessionExpiredSoon : 120,

    demoRoles : false,
    userData : true,
    userImpersonate : true,

    matomo : {
        url : '//dashboard.ketchum.flyingspoon.de/',
        id : null,
    }
};
